/**
 * Onboarding route map + step config.
 *
 * Step 0 is the story intro (no progress bar).
 * Steps 1-5 each show a progress fraction 1/5 .. 5/5.
 * The "Lewati" handler on every step jumps directly to /summary.
 *
 * MVP (2026-08-15): langkah Quiz Tema dihapus — tema PAUD 14 berasal dari
 * funpaper tema (konten premium), sedangkan pool MVP hanya funpaper harian
 * yang tidak punya tema. Quiz Aktivitas tetap ada karena activity_label
 * memang tersedia di pool harian.
 */

export const ONBOARDING_ROUTES = {
  story: '/',
  welcome: '/welcome',
  childProfile: '/child-profile',
  quizActivity: '/quiz-activity',
  quizCount: '/quiz-count',
  summary: '/summary',
} as const;

export type OnboardingStepKey = keyof typeof ONBOARDING_ROUTES;

export type OnboardingStep = {
  key: OnboardingStepKey;
  path: (typeof ONBOARDING_ROUTES)[OnboardingStepKey];
  /** Progress in [0, 1] shown on the bar. */
  progress: number;
  /** Right-aligned counter under the bar, e.g. "2 / 5". */
  stepLabel: string;
  /** Short human label, used in placeholder copy. */
  title: string;
};

export const ONBOARDING_STEPS: readonly OnboardingStep[] = [
  {
    key: 'story',
    path: ONBOARDING_ROUTES.story,
    progress: 0,
    stepLabel: 'Story',
    title: 'Story Intro',
  },
  {
    key: 'welcome',
    path: ONBOARDING_ROUTES.welcome,
    progress: 1 / 5,
    stepLabel: '1 / 5',
    title: 'Selamat Datang',
  },
  {
    key: 'childProfile',
    path: ONBOARDING_ROUTES.childProfile,
    progress: 2 / 5,
    stepLabel: '2 / 5',
    title: 'Profil Anak',
  },
  {
    key: 'quizActivity',
    path: ONBOARDING_ROUTES.quizActivity,
    progress: 3 / 5,
    stepLabel: '3 / 5',
    title: 'Quiz Aktivitas',
  },
  {
    key: 'quizCount',
    path: ONBOARDING_ROUTES.quizCount,
    progress: 4 / 5,
    stepLabel: '4 / 5',
    title: 'Jumlah Worksheet',
  },
  {
    key: 'summary',
    path: ONBOARDING_ROUTES.summary,
    progress: 5 / 5,
    stepLabel: '5 / 5',
    title: 'Selesai',
  },
];

/** Lookup a step config by its route path (for progress bar + label). */
export function getStepByPath(path: string): OnboardingStep | undefined {
  return ONBOARDING_STEPS.find((s) => s.path === path);
}
